/* DATE — First-Sip Draw winner quantity guard. v2, 2026-08-01.
 *
 * Caps the 12-Pack SUBSCRIPTION line at 1 per cart, FOR WINNERS ONLY.
 *
 * v1 armed off sessionStorage alone, which is per-tab. A winner could apply the code in
 * one tab (the code lives in a cookie, shared across tabs) and then add unlimited free
 * 12-Packs from a second tab that had never seen the winner page. v2 arms off localStorage
 * and a cookie as well, both of which are shared across every tab on the origin.
 *
 * Self-disables after HARD_STOP regardless of any stored flag.
 * Safe to delete the <script> tag in snippets/date-cart-sub-upsell.liquid after 2026-08-07.
 */
(function () {
  var KEY = 'fsw_winner';
  var EXP = 'fsw_winner_exp';
  var SUB_VARIANT = '47402138927362';
  var MAX = 1;
  var TTL_MS = 14 * 24 * 60 * 60 * 1000;
  var HARD_STOP = Date.parse('2026-08-15T00:00:00Z');
  var LP = '/pages/first-sip-winners';

  var _fetch = (typeof window.fetch === 'function') ? window.fetch.bind(window) : null;

  function now() { return (new Date()).getTime(); }

  function readCookie() {
    try { return /(?:^|;\s*)fsw_winner=1(?:;|$)/.test(document.cookie); } catch (e) { return false; }
  }

  function mark() {
    var until = now() + TTL_MS;
    try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
    try { localStorage.setItem(KEY, '1'); localStorage.setItem(EXP, String(until)); } catch (e) {}
    try { document.cookie = KEY + '=1; path=/; max-age=' + Math.floor(TTL_MS / 1000) + '; SameSite=Lax'; } catch (e) {}
  }

  function clearMark() {
    try { sessionStorage.removeItem(KEY); } catch (e) {}
    try { localStorage.removeItem(KEY); localStorage.removeItem(EXP); } catch (e) {}
    try { document.cookie = KEY + '=; path=/; max-age=0; SameSite=Lax'; } catch (e) {}
  }

  /* Arm the guard from ANY cross-tab channel. */
  function armed() {
    if (now() > HARD_STOP) { clearMark(); return false; }
    try { if (sessionStorage.getItem(KEY) === '1') return true; } catch (e) {}
    try {
      if (localStorage.getItem(KEY) === '1') {
        var exp = parseInt(localStorage.getItem(EXP), 10);
        if (!exp || now() < exp) return true;
        clearMark();
        return false;
      }
    } catch (e) {}
    return readCookie();
  }

  /* Landing page with a code in the URL = this browser belongs to a winner. Mark it here
     rather than in the page's inline script, so the marking rules live in one file. */
  try {
    if (location.pathname.indexOf(LP) === 0 && /[?&]c=[^&\s]/.test(location.search)) mark();
  } catch (e) {}

  if (!armed()) return;

  function isSub(v) {
    if (v === null || v === undefined) return false;
    var s = String(v);
    return s === SUB_VARIANT || s.indexOf(SUB_VARIANT + ':') === 0;
  }

  /* 1. Clamp quantity inputs in the DOM. */
  function clampInputs() {
    var els = document.querySelectorAll('input[name="quantity"], input.quantity__input, input[name^="updates["]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      el.setAttribute('max', String(MAX));
      if (parseInt(el.value, 10) > MAX) {
        el.value = MAX;
        try { el.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
      }
    }
  }

  /* 2. Rewrite outbound cart payloads. */
  function capObj(j) {
    var changed = false, i, k;
    if (j.quantity != null && isSub(j.id) && +j.quantity > MAX) { j.quantity = MAX; changed = true; }
    if (Object.prototype.toString.call(j.items) === '[object Array]') {
      for (i = 0; i < j.items.length; i++) {
        if (isSub(j.items[i].id) && +j.items[i].quantity > MAX) { j.items[i].quantity = MAX; changed = true; }
      }
    }
    if (j.updates && typeof j.updates === 'object') {
      for (k in j.updates) {
        if (isSub(k) && +j.updates[k] > MAX) { j.updates[k] = MAX; changed = true; }
      }
    }
    return changed;
  }

  function capPairs(p) {
    var changed = false;
    try {
      if (isSub(p.get('id')) && +p.get('quantity') > MAX) { p.set('quantity', String(MAX)); changed = true; }
    } catch (e) {}
    return changed;
  }

  function isCartUrl(u) { return /\/cart\/(add|change|update)/.test(String(u || '')); }

  function capBody(url, opts) {
    if (!isCartUrl(url) || !opts || !opts.body) return;
    var b = opts.body;
    if (typeof b === 'string') {
      if (b.charAt(0) === '{') {
        try { var j = JSON.parse(b); if (capObj(j)) opts.body = JSON.stringify(j); } catch (e) {}
      } else {
        try { var p = new URLSearchParams(b); if (capPairs(p)) opts.body = p.toString(); } catch (e) {}
      }
    } else if (typeof FormData !== 'undefined' && b instanceof FormData) {
      capPairs(b);
    } else if (typeof URLSearchParams !== 'undefined' && b instanceof URLSearchParams) {
      capPairs(b);
    }
  }

  /* 3. Reconcile the live cart — backstop for anything the interceptors miss. */
  var reconciling = false;
  function reconcile() {
    if (!_fetch || reconciling) return;
    reconciling = true;
    _fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items) return null;
        for (var i = 0; i < cart.items.length; i++) {
          var it = cart.items[i];
          if (String(it.variant_id) === SUB_VARIANT && it.quantity > MAX) {
            return _fetch('/cart/change.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: it.key, quantity: MAX })
            }).then(function () {
              if (/\/cart/.test(location.pathname)) location.reload();
              return null;
            });
          }
        }
        return null;
      })
      ['catch'](function () {})
      .then(function () { reconciling = false; }, function () { reconciling = false; });
  }

  if (_fetch) {
    window.fetch = function (u, o) {
      var url = (typeof u === 'string') ? u : (u && u.url) || '';
      try { capBody(url, o); } catch (e) {}
      var r = _fetch.apply(null, arguments);
      try {
        if (isCartUrl(url) && r && typeof r.then === 'function') {
          r.then(function () { setTimeout(reconcile, 400); }, function () {});
        }
      } catch (e) {}
      return r;
    };
  }

  if (window.XMLHttpRequest && XMLHttpRequest.prototype.open && XMLHttpRequest.prototype.send) {
    var XO = XMLHttpRequest.prototype.open;
    var XS = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__fswUrl = u; return XO.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function (b) {
      try { var o = { body: b }; capBody(this.__fswUrl, o); b = o.body; } catch (e) {}
      try { if (isCartUrl(this.__fswUrl)) setTimeout(reconcile, 600); } catch (e) {}
      return XS.call(this, b);
    };
  }

  /* 4. Last line of defence: reconcile before any checkout hand-off, and block the click
        long enough for the correction to land. */
  function guardCheckout() {
    document.addEventListener('click', function (ev) {
      var t = ev.target;
      while (t && t !== document) {
        var nm = (t.getAttribute && (t.getAttribute('name') || '')) || '';
        var hr = (t.getAttribute && (t.getAttribute('href') || '')) || '';
        if (nm === 'checkout' || /\/checkout/.test(hr)) { reconcile(); break; }
        t = t.parentNode;
      }
    }, true);
  }

  function boot() { clampInputs(); reconcile(); guardCheckout(); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('pageshow', reconcile);
  try { new MutationObserver(clampInputs).observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
})();
